export const sucessErrorMsg = {
  companySucessMsg: 'sucess fecting Company details',
  companyErrorMsg: 'error fetching Company details',
}

export const lmsIntent = {
  getOrderInvoices: 'getOrderInvoices',
  createOrderEvent: 'createOrderEvent',
  getTestPriceFromOdoo: 'getTestPriceFromOdoo',
  updateLabOrderInvoice: 'updateLabOrderInvoice',
  createLabInvoice: 'createLabInvoice',
  getAllPanelsApi: 'getAllPanelsApi',
}
